import { render, staticRenderFns } from "./SpecialRateCarpark.vue?vue&type=template&id=2bfc0496&"
import script from "./SpecialRateCarpark.vue?vue&type=script&lang=js&"
export * from "./SpecialRateCarpark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports